<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="handleOpenAdd">
                {{ $t('labels.addSettingMarketplace') }}
            </hts-form-button>
        </div>

        <hts-data-table
            ref="dataTables"
            :headers="headers"
            :server="apiList"
            use-selection
            :use-archive="apiArchive"
            store-name="driverDataTable"
            store-key="Driver" />

        <AddSettingMarketplace
            ref="addSettingMarketplace"
            @refreshTable="refreshTables()" />

        <EditSettingMarketplace
            ref="editSettingMarketplace"
            @refresh-tables="refreshTables()" />

        <DetailSettingMarketplace ref="detailSettingMarketplace" />

        <hts-modal
            :show="showDeleteConfirm"
            :title="$t('labels.deleteSettingMarketplace')"
            type="confirm"
            :content="$t('labels.confirmDeleteSettingMarketplace')"
            @hide="showDeleteConfirm = false"
            @confirm="confirmDelete" />
    </div>
</template>

<script lang="ts" setup>
import AddSettingMarketplace from './ignore/setting/add.vue'
import DetailSettingMarketplace from './ignore/setting/detail.vue'
import EditSettingMarketplace from './ignore/setting/edit.vue'
import Actions from '~/pages/trucker-[id]/driver/ignore/actions.vue'
import layoutPermissions from '~/data/permissions/layout-permissions'

const dataTables = ref()
const addSettingMarketplace = ref()
const editSettingMarketplace = ref()
const detailSettingMarketplace = ref()
const { $formatters, $toast, $t } = useNuxtApp()
const showDeleteConfirm = ref(false)
const selectedItemId = ref('')

const handleOpenAdd = () => {
  addSettingMarketplace.value && addSettingMarketplace.value.open()
}

const handleViewDetail = (data: any) => {
  detailSettingMarketplace.value && detailSettingMarketplace.value.open(data._id)
}

const handleEditSetting = (data: any) => {
  editSettingMarketplace.value && editSettingMarketplace.value.open(data._id)
}

const handleDeleteSetting = (data: any) => {
  selectedItemId.value = data._id
  showDeleteConfirm.value = true
}

const confirmDelete = () => {
  const api = {
    method: 'delete',
    url: '/marketplace/setting'
  }

  $api(api, { body: { ids: [selectedItemId.value] } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      refreshTables()
      showDeleteConfirm.value = false
      process.client && $toast().success($t('labels.deleteSuccess'))
    }
  })
}

const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}

const apiList = {
  method: 'post',
  url: '/marketplace/setting/list'
}

const apiArchive = {
  api: {
    method: 'delete',
    url: '/marketplace/setting/archive'
  },
  permissions: checkPermission(layoutPermissions.order_archive)
}

const headers = [
  {
    field: 'shipmentTypeName',
    headerName: 'Loại hình vận chuyển',
    resizable: true,
    sortable: true,
    minWidth: 180,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'workflowName',
    headerName: 'workflowName',
    resizable: true,
    sortable: true,
    minWidth: 180,
    filter: 'agTextColumnFilter'
  },
  {
    field: 'createdAt',
    headerName: $t('labels.createdAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      if (params.data.createdAt) {
        return $formatters.datetime(params.data.createdAt)
      }
    }
  },
  {
    field: 'updatedAt',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    filter: 'agDateColumnFilter',
    valueGetter: (params: any) => {
      if (params.data.updatedAt) {
        return $formatters.datetime(params.data.updatedAt)
      }
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: Actions,
    cellRendererParams: {
      storeKey: 'driverDataTable',
      storeName: 'Driver',
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: true,
          click: handleViewDetail
        },
        {
          icon: 'hi-pencil-square-icon',
          label: $t('labels.edit'),
          class: 'text-main-600 hover:text-main-500',
          permissions: true,
          click: handleEditSetting
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: true,
          click: handleDeleteSetting,
          isArchive: true
        }
      ]
    }
  }
]
</script>
